import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import './scss/Comments.scss';
import ImagePlaceholder from '../Global/ImagePlaceholder';
import { sanitizeHtml, timeAgo } from '../../utils/helpers';
import { config } from '../../config';

import {
    mentionedMemberIds,
    resetMentionedIds,
} from "../../redux/Slices/mentionedSlice";
import { fetchCardById } from '../../redux/Slices/cardSlice';
import { addCommentOptimistically, fetchActivities, finalizeCommentOptimistically, setCommentPostingState, deleteCommentOptimistically, setHighlightTarget } from '../../redux/Slices/activitiesSlice';
import Editor from '../LexicalEditor/Editor';
import ActivityZone from '../icons/ActivityZone';

const Comments = ({ cardId, isActivityDetails, layout = '', isEditingDescription, isReadOnly = false }) => {
    const { user, loading: userLoading, error: userError } = useSelector((state) => state.user);
    // const { activities, activitiesLoading: loading } = useSelector((state) => state.activities);

    const [comments, setComments] = useState([]);
    const [newComment, setNewComment] = useState('');
    const [editingComment, setEditingComment] = useState('');
    const [isAddComment, setAddComment] = useState('');
    const [isCommentBoxClicked, setCommentBoxClicked] = useState(true);


    const dispatch = useDispatch();

    const mentionedIds = useSelector((state) => state.mentioned.mentionedMemberIds);

    // useEffect(() => {
    //     fetchComments();
    // }, [cardId]);



    const fetchComments = async () => {
        
        try {
            const response = await fetch(config.API_URI + `/v1/cards/${cardId}/comments`, {
                
                credentials: 'include',
            });

            if (!response.ok) {
                throw new Error('Failed to fetch comments');
            }

            const data = await response.json();
            setComments(data);
        } catch (error) {
            console.error('Error fetching comments:', error);
        }
    };

    const handleAddComment = async (e) => {
        if (!newComment.trim()) return;

        // Create the new comment object for optimistic UI
        const tempId = Date.now();
        const newCommentData = {
            _id: tempId, // local display id
            _tempId: tempId, // used to reconcile with server
            details: newComment,
            initiator: {
                _id: user?.user?._id,
                name: user?.user?.name,
                profilePicture: user?.user.profilePicture,
            },
            createdAt: new Date().toISOString(),
            actionType: 'ADDED_COMMENT',
            actionTypeId: null, // Will be set to server commentId on success
        };

        // Dispatch the optimistic update (will show "posting..." state)
        dispatch(addCommentOptimistically(newCommentData));

        // Clear input and close editor
        const originalComment = newComment;
        setNewComment('');
        setAddComment(false);

        try {
            const response = await fetch(`${config.API_URI}/v1/cards/${cardId}/comments`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({
                    comment: originalComment,
                    member: user?.user?._id,
                    reacts: [],
                    mentionedIds,
                }),
            });

            if (!response.ok) {
                throw new Error('Failed to add comment');
            }

            const addedComment = await response.json();

            // Remove posting state
            dispatch(setCommentPostingState({ tempId, isPosting: false }));

            // Finalize optimistic item with the real comment id
            if (addedComment?.commentId) {
                dispatch(finalizeCommentOptimistically({ tempId, commentId: addedComment.commentId }));
                // Highlight this new comment after fetch
                dispatch(setHighlightTarget({ type: 'comment', id: addedComment.commentId }));
            }

            // Fetch activities to get the real server data
            dispatch(fetchActivities({ cardId }));
            dispatch(resetMentionedIds());
        } catch (error) {
            console.error('Error adding comment:', error);
            // Remove the optimistic comment on error
            dispatch(deleteCommentOptimistically(tempId));
            // Restore the input
            setNewComment(originalComment);
            setAddComment(true);
        }
    };




    return (
        <div className={`comment-section${' ' + layout}`}>


            {
                layout !== 'collumn' && (
                    <div className="activity-header">
                        <h3>
                            <ActivityZone size={24} />
                            Comments & Activity
                        </h3>
                    </div>
                )
            }
            {!isReadOnly && (
                <div className="comment comment-input-field">

                    {
                        layout !== 'collumn' && (
                            <>
                                {user?.user.profilePicture ? (
                                    <img src={user?.user.profilePicture} alt={user?.user.username} className="comment__profile-img" loading="lazy" />
                                ) : (
                                    <ImagePlaceholder text={user?.user.username} onlineIndicator={false} />
                                )}

                            </>
                        )
                    }

                    <div className={`comment__content comment-editor-field`}>
                        <div className="comment__actions">
                            {
                                isAddComment ? (
                                    <>
                                        {
                                            layout == 'collumn' && (
                                                <div className='comment-by__header'>
                                                    {user?.user.profilePicture ? (
                                                        <img src={user?.user.profilePicture} alt={user?.user.username} className="comment__profile-img" loading="lazy" />
                                                    ) : (
                                                        <ImagePlaceholder size={10} text={user?.user.username} onlineIndicator={false} />
                                                    )}

                                                    <div className='comment-by'>
                                                        <strong>{user?.user.name}</strong>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        <Editor
                                            value={newComment}
                                            setDescription={setNewComment}
                                            setIsEditingDescription={setAddComment}
                                            handleUpdateCard={handleAddComment}
                                            cardId={cardId}
                                            context="comment"
                                        />
                                    </>

                                ) : (
                                    <div className="card-comment-content write-comment-field" onClick={() => setAddComment(true)}>
                                        Write a comment...
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Comments;
